/* eslint-disable no-param-reassign, no-unused-vars */

export default {
  state: {
    // WIP
    profile: {
      firstName: "",
      lastName: "",
      sub: ""
    },
    status: ""
  },

  getters: {
    getProfile: ({ profile }) => profile,
    getProfileIsLoaded: ({ profile }) => !!profile.name
  },

  mutations: {
    setStatusLoading({ status }) {
      status = "loading";
    },

    setStatusSuccess(state, { profile }) {
      state.status = "success";
      state.profile = profile;
    },

    setStatusError({ status }) {
      status = "error";
    }
  },

  namespaced: true
};
